import { Button, Form, Input } from 'antd';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface TicketSaveFormProps {
  onSaveTicket?: (data: { name: string; comment: string }) => void;
}

const TicketSaveForm: FC<TicketSaveFormProps> = ({ onSaveTicket }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values: { name: string; comment: string }) => {
    if (!onSaveTicket) return;
    setLoading(true);
    try {
      await onSaveTicket(values);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold mb-4">{t('common:save_ticket')}</h2>
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          name="name"
          label={t('common:ticket_name')}
          rules={[{ required: true, message: t('common:ticket_name_required') }]}
        >
          <Input placeholder={t('common:enter_ticket_name')} />
        </Form.Item>

        <Form.Item name="comment" label={t('common:comment')}>
          <Input.TextArea rows={4} placeholder={t('common:enter_comment')} />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" block loading={loading}>
            {t('common:save')}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default TicketSaveForm;
